import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "../components/admin/AdminLayout";
import DashboardOverview from "../components/admin/DashboardOverview";
import UserManagement from "../components/admin/UserManagement";
import SuperadminQueue from "../components/admin/SuperadminQueue";
import NotesManager from "../components/admin/NotesManager";
import EditorialManager from "../components/admin/EditorialManager";
import MCQGroupedView from "../components/admin/MCQGroupedView";
import MainsPracticeManager from "../components/admin/MainsPracticeManager";
import StudyPlanPricing from "../components/admin/StudyPlanPricing";
import StudyPlanManager from "../components/admin/StudyPlanManager";
import ExamCycleManager from "../components/admin/ExamCycleManager";
import EditPrelimsTest from "../components/admin/testSeries/EditPrelimsTest";

// ✅ Monthly Magazine
import MonthlyMagazineManager from "../components/admin/MonthlyMagazineManager";
import AdminSupport from "../components/admin/support/AdminSupport";

// ✅ Test Series Components
import MainsTestUpload from "../components/admin/testSeries/MainsTestUpload";
import MainsTestViewManager from "../components/admin/testSeries/MainsTestViewManager";
import MainsSubmissionViewer from "../components/admin/testSeries/MainsSubmissionViewer";
import PrelimsTestUpload from "../components/admin/testSeries/PrelimsTestUpload";
import PrelimsTestViewManager from "../components/admin/testSeries/PrelimsTestViewManager";
import TestSeriesManager from "../components/admin/testSeries/TestSeriesManager";
import MainsTestReviewList from "../components/admin/testSeries/MainsTestReviewList";

// ✅ Announcement Manager
import AnnouncementManager from "../components/admin/AnnouncementManager";

// ✅ Profile Settings
import ProfileSettings from "../components/admin/Profile/ProfileSettings";

const Placeholder = ({ title }) => (
  <div className="p-4 text-xl text-gray-700 font-semibold">
    {title}
  </div>
);




const AdminDashboard = () => {
  const user = JSON.parse(
    localStorage.getItem("user")
  );

  if (!user || user.role !== "admin") {
    return <Navigate to="/login" replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<AdminLayout />}>

        {/* Default Route */}
        <Route
          index
          element={
            <Navigate
              to="overview"
              replace
            />
          }
        />



        {/* ========================= */}
        {/* Main Sections */}
        {/* ========================= */}

        <Route
  path="exam-cycle"
  element={<ExamCycleManager />}
/>

        <Route
          path="overview"
          element={<DashboardOverview />}
        />

        <Route
          path="users"
          element={<UserManagement />}
        />

        <Route
          path="superadmin-queue"
          element={<SuperadminQueue />}
        />

        <Route
          path="editorials"
          element={<EditorialManager />}
        />

        <Route
          path="mcqs"
          element={<MCQGroupedView />}
        />

        <Route
          path="notes"
          element={<NotesManager />}
        />

        <Route
          path="mains-practice"
          element={<MainsPracticeManager />}
        />

        <Route
          path="plans"
          element={<StudyPlanPricing />}
        />

        <Route
          path="plans/manage"
          element={<StudyPlanManager />}
        />


        {/* ========================= */}
        {/* Monthly Magazine */}
        {/* ========================= */}

        <Route
          path="monthly-magazines"
          element={<MonthlyMagazineManager />}
        />

        <Route
  path="support"
  element={<AdminSupport />}
/>


        {/* ========================= */}
        {/* Test Series */}
        {/* ========================= */}

        <Route
          path="test-series"
          element={<TestSeriesManager />}
        />

        <Route
          path="test-series/prelims/upload"
          element={<PrelimsTestUpload />}
        />

        <Route
          path="test-series/prelims/view"
          element={<PrelimsTestViewManager />}
        />

        <Route
  path="test-series/prelims/edit/:id"
  element={<EditPrelimsTest />}
/>

        <Route
          path="test-series/mains/upload"
          element={<MainsTestUpload />}
        />

        <Route
          path="test-series/mains/view"
          element={<MainsTestViewManager />}
        />

        <Route
          path="test-series/mains/review"
          element={<MainsTestReviewList />}
        />

        <Route
          path="test-series/mains/submission/:testId"
          element={<MainsSubmissionViewer />}
        />


        {/* ========================= */}
        {/* Announcements */}
        {/* ========================= */}

        <Route
          path="announcements"
          element={<AnnouncementManager />}
        />


        {/* ========================= */}
        {/* Profile Settings */}
        {/* ========================= */}

        <Route
          path="settings"
          element={<ProfileSettings />}
        />

      </Route>
    </Routes>
  );
};

export default AdminDashboard;